import { useState } from 'react';
import CloseAC from '../CloseAc';
import EmailSettingsAc from '../EmailSettingsAc';
import InvoiceSettingsAc from '../InvoiceSettingsAc';
import PaymentSettingsAc from '../PaymentSettingsAc';
import NewGeneralSettingAC from '../GeneralSettings/newGeneralSettingAc';
import WareHouseAddressAc from '../Warehouse/wareHouseAddressAc';

const AllSettings = ({ setHideFloatBtn }) => {
  const [expandedEmail, setExpandedEmail] = useState(false);
  const [selectEmailTemp, setSelectEmailTemp] = useState({ select: 0, Key: '' });

  return (
    <div>
      <NewGeneralSettingAC setHideFloatBtn={setHideFloatBtn} />
      <EmailSettingsAc
        key={selectEmailTemp.Key}
        selectEmailTemp={selectEmailTemp.select}
        expanded={expandedEmail}
        setExpanded={setExpandedEmail}
        setHideFloatBtn={setHideFloatBtn}
      />
      <InvoiceSettingsAc setHideFloatBtn={setHideFloatBtn} />
      <PaymentSettingsAc setSelectEmailTemp={setSelectEmailTemp} emailExpand={setExpandedEmail} setHideFloatBtn={setHideFloatBtn} />
      <CloseAC setHideFloatBtn={setHideFloatBtn} />
      {/* <WareHouseAddressAc setHideFloatBtn={setHideFloatBtn} /> */}
    </div>
  );
};

export default AllSettings;
